angular.module('forms', [
    //third party
    'angularLocalStorage',
    'gettext',
    'headroom',
    'lodash',
    'ngAnimate',
    'ngTouch',
    'restangular',
    'toaster',
    'ui.bootstrap',
    'ui.router',
    'apEasyScroller',
    'ngMessages',

    'app',

    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common',
    'aprima-provider-api',
    'aprima-patient-api',
    'aprima-utils'
])
    .constant('FormsId', {
        TimeFrameId: {
            Clear: '00000000-0000-0000-0000-000000000000',
            Calendar: '2A65CC34-B700-4BE1-BC0C-BC3947ABDBB4',
            DaysAgo: 'E21ED176-0B54-401C-9FD9-F4376AA1B8B6',
            WeeksAgo: 'C887168A-B5E3-4547-B8C7-190555956062',
            MonthsAgo: '10051306-DC98-45A3-B9BB-9C1C1FD06FC2',
            YearsAgo: 'D903B3D9-796E-45F2-BE6F-EC676863C0B5',
            Childhood: '4CE23CF0-C9BB-4016-900F-76A567A3C82C',
            Teenager: '3FF31D6D-0706-429D-9ACF-C54E081ECD29',
            Birth: '86317D78-C519-4FE3-8F02-B794FFB00357'
        },
        HistoryGroupId: {
            ProblemDiagnosis: '0238A133-904E-4E49-BDBA-4EB3CB3B39A7',
            Family: 'A3FAF896-B328-4364-9621-012F8C6643BB',
            Immunization: '00000000-0000-0000-0000-000000000111'
        },
        ModalInstanceReturnId: {
            Accept: 'accept',
            Cancel: 'cancel'
        }
    });